import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#1A1631] py-6 border-t border-[#EF7C34]/20">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 text-center text-sm text-slate-500">
        <p className="space-x-2">
          &copy; 2025 Apoello Ltd. All rights reserved.
          <span> · </span>
          <Link to="/privacy-policy" className="underline hover:text-[#F89B3F]">
            Privacy Policy
          </Link>
          <span> · </span>
          <span>
            This website uses strictly necessary cookies for functionality and security. No tracking or advertising cookies are used.
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
